<template>
  <Category cate-name="career" category-name="キャリアアップ" />
</template>

<script>
import Category from '@/components/Category.vue'
export default {
  components: {
    Category
  }
}
</script>

<style scoped></style>
